module.exports = __webpack_public_path__ + "img/home-pic-5.876333e6.jpg";